import styles from "./Markdown.module.css";
import { Box, Code, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";
import type { Components } from "react-markdown";
import ReactMarkdown from "react-markdown";

const markdownComponents = {
  h1: ({ children }: { children?: ReactNode }) => (
    <Title order={1} mb="sm">
      {children}
    </Title>
  ),
  h2: ({ children }: { children?: ReactNode }) => (
    <Title order={2} mb="xs">
      {children}
    </Title>
  ),
  h3: ({ children }: { children?: ReactNode }) => (
    <Title order={3} mb="xs">
      {children}
    </Title>
  ),
  h4: ({ children }: { children?: ReactNode }) => (
    <Title order={4} mb="xs">
      {children}
    </Title>
  ),
  h5: ({ children }: { children?: ReactNode }) => (
    <Title order={5} mb="xs">
      {children}
    </Title>
  ),
  h6: ({ children }: { children?: ReactNode }) => (
    <Title order={6} mb="xs">
      {children}
    </Title>
  ),
  p: ({ children }: { children?: ReactNode }) => (
    <Text component="p" mb="md" size="sm" fw={500}>
      {children}
    </Text>
  ),
  strong: ({ children }: { children?: ReactNode }) => (
    <Text component="strong" size="sm" fw={600}>
      {children}
    </Text>
  ),
  code: ({ children }: { children?: ReactNode }) => <Code>{children}</Code>
};

export default function Markdown({ children, components = {} }: { children: string; components?: Components }) {
  return (
    <Box className={styles.markdown}>
      <ReactMarkdown components={{ ...markdownComponents, ...components }}>{children}</ReactMarkdown>
    </Box>
  );
}
